export default "__VITE_ASSET__Delcptn___ 400w, __VITE_ASSET__BTNXskvD__ 800w, __VITE_ASSET__BwZ6owTl__ 1024w";